import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import { getDefaultVsic } from '../../../../helper'
import CorpService from '../../core/CorpService'

export const postLiquidityAndSolvencyAndCoverAge = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/liquiditySolvencyCoverage',
  async (params, { rejectWithValue }) => {
    try {
      if (params?.isDynamicReport) {
        const {
          vsics,
          companyInfo = {},
          defaultIndustryId,
          compareIndustryId,
        } = params || {}

        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id

        const res = await CorpService.postLiquidityAndSolvencyAndCoverAge({
          vsicDefault: defaultVsicId,
          vsicCompare: compareIndustryId,
          organizationId: companyInfo?.organizationId,
        })

        return res.success
          ? { data: res.data, defaultVsicId }
          : rejectWithValue({ isLoading: false })
      } else {
        const { vsicDefault, ...others } = params || {}
        const res = await CorpService.postLiquidityAndSolvencyAndCoverAge({
          vsicDefault,
          ...others,
        })

        return res.success
          ? { data: res.data, defaultVsicId: vsicDefault }
          : rejectWithValue({ isLoading: false })
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadLiquiditySolvencyCoverage = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/liquiditySolvencyCoverage/export',
  async (params) => {
    try {
      const res = await CorpService.downloadLiquidityAndSolvencyAndCoverAge(
        params,
      )
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
